(() => {
    const galleryGrid = document.getElementById('photo-grid');

    if (!galleryGrid) {
        return;
    }

    const IMAGE_COUNT = 19;
    const FALLBACK_WIDTH = 2000;
    const FALLBACK_HEIGHT = 1125;
    const GALLERY_VERSION = '20251028';
    const versionParam = `?v=${GALLERY_VERSION}`;

    const images = Array.from({ length: IMAGE_COUNT }, (_, index) => {
        const id = index + 1;
        const fileName = `${id}.jpg`;
        const src = `/assets/gallery/${fileName}${versionParam}`;

        return {
            id,
            src,
            alt: `Dighomi City photo ${id}`,
        };
    });

    const dimensionPromises = images.map((item) => {
        const anchor = document.createElement('a');
        anchor.href = item.src;
        anchor.className = 'photo-grid__item';
        anchor.setAttribute('aria-label', item.alt);
        anchor.dataset.pswpSrc = item.src;

        const img = document.createElement('img');
        img.src = item.src;
        img.alt = item.alt;
        img.loading = 'lazy';

        anchor.appendChild(img);
        galleryGrid.appendChild(anchor);

        return new Promise((resolve) => {
            const applyDimensions = (width, height) => {
                anchor.dataset.pswpWidth = width;
                anchor.dataset.pswpHeight = height;
                resolve();
            };

            const handleLoad = () => {
                const { naturalWidth, naturalHeight } = img;
                const width = naturalWidth || FALLBACK_WIDTH;
                const height = naturalHeight || FALLBACK_HEIGHT;
                applyDimensions(width, height);
            };

            if (img.complete) {
                if (img.naturalWidth) {
                    handleLoad();
                } else {
                    applyDimensions(FALLBACK_WIDTH, FALLBACK_HEIGHT);
                }
            } else {
                img.addEventListener('load', handleLoad, { once: true });
                img.addEventListener(
                    'error',
                    () => applyDimensions(FALLBACK_WIDTH, FALLBACK_HEIGHT),
                    { once: true }
                );
            }
        });
    });

    Promise.all(dimensionPromises).then(() => {
        if (
            typeof window.PhotoSwipeLightbox !== 'function' ||
            typeof window.PhotoSwipe !== 'function'
        ) {
            console.warn('PhotoSwipe assets have not been loaded.');
            return;
        }

        const lightbox = new window.PhotoSwipeLightbox({
            gallery: '#photo-grid',
            children: 'a',
            showHideAnimationType: 'zoom',
            secondaryZoomLevel: 1.5,
            pswpModule: window.PhotoSwipe,
            padding: {
                top: 24,
                bottom: 24,
                left: 24,
                right: 24,
            },
        });

        lightbox.init();
    });
})();

document.addEventListener('DOMContentLoaded', () => {
    // Existing behavior: if we land on a hash, scroll to that floor heading.
    location.hash && scrollTo(getScrollEl());
});
window.addEventListener('hashchange', () => {
    scrollTo(getScrollEl());
});

function scrollTo(element) {
    setTimeout(() => {
        window.scroll({
            behavior: 'smooth',
            left: 0,
            top: element.offsetTop - 75,
        });
    }, 1000);

    element.style.backgroundColor = '#aaa';
    setTimeout(() => {
        element.style.backgroundColor = 'unset';
    }, 1500);
}

function getScrollEl() {
    switch (location.hash) {
        case '#photo':
            return document.getElementById('photo-gallery-heading');
        case '#video':
            return document.getElementById('video-gallery-heading');
        default:
            break;
    }
}
